import { get, put } from '@utils/xhr';

export const getConfig = async () => {
  try {
    const response = await get({ url: `${process.env.apiPath}/api/config` });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateConfig = async (id, newConfig) => {
  try {
    const response = await put({
      url: `${process.env.apiPath}/api/config`,
      data: {
        id,
        ...newConfig
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
